import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';

import AdminFTPAccountsListHeader from './ListHeader';
import AdminFTPAccountsListItem from './ListItem';

const AdminFTPAccountsList = ({
  accounts,
  openFTPAccountEditModal,
  handleDeleteAccount,
  ...props
}) => (
  <div className="table-wrapper">
    <Table className="users-list accounts-list" responsive>
      <thead>
        <AdminFTPAccountsListHeader
          {...props}
        />
      </thead>
      <tbody>
        {accounts.map(account => (
          <AdminFTPAccountsListItem
            key={account.id}
            account={account}
            handleDeleteAccount={handleDeleteAccount}
            openFTPAccountEditModal={openFTPAccountEditModal}
          />
        ))}
      </tbody>
    </Table>
  </div>
);

AdminFTPAccountsList.propTypes = {
  accounts: PropTypes.array.isRequired,
  orderBy: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  handleChangeOrder: PropTypes.func.isRequired,
  handleDeleteAccount: PropTypes.func.isRequired,
  openFTPAccountEditModal: PropTypes.func.isRequired,
};

export default AdminFTPAccountsList;
